document.addEventListener("DOMContentLoaded", () => {
  handleAboutSwiper();
});

function handleAboutSwiper() {
  // Initialize Swiper
  const aboutSwiper = new Swiper(".mc-about__swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".mc-about__slider-arrow--next",
      prevEl: ".mc-about__slider-arrow--prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    on: {
      init: function () {
        updateProgressBar(this);
      },
      slideChange: function () {
        updateProgressBar(this);
      },
      sliderMove: function () {
        updateProgressBar(this);
      },
      transitionEnd: function () {
        updateProgressBar(this);
      },
    },
  });

  // Progress bar update
  function updateProgressBar(swiper) {
    const progressBar = document.querySelector(
      ".swiper-progress-bar .progress"
    );
    if (progressBar) {
      const progress = (swiper.realIndex + 1) / swiper.slides.length;
      progressBar.style.width = `${progress * 100}%`;
    }
  }

  // Video modal logic
  document.querySelectorAll(".mc-about__video-play").forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const imageContainer = button.closest(".mc-about__image-container");
      const videoUrl = imageContainer
        ? imageContainer.getAttribute("data-video-url")
        : null;
      if (videoUrl) openVideoModal(videoUrl);
    });
  });
}

function openVideoModal(videoUrl) {
  const modal = document.createElement("div");
  modal.className = "mc-about__video-modal";

  const modalContent = document.createElement("div");
  modalContent.className = "mc-about__video-modal-content";

  const closeButton = document.createElement("button");
  closeButton.className = "mc-about__video-modal-close";
  closeButton.innerHTML = "&times;";

  const videoFrame = document.createElement("iframe");
  videoFrame.src = videoUrl;
  videoFrame.allowFullscreen = true;

  modalContent.appendChild(closeButton);
  modalContent.appendChild(videoFrame);
  modal.appendChild(modalContent);
  document.body.appendChild(modal);

  // Escape key handler
  function handleEscape(e) {
    if (e.key === "Escape") {
      closeModal();
    }
  }

  function closeModal() {
    document.body.removeChild(modal);
    document.removeEventListener("keydown", handleEscape);
  }

  closeButton.addEventListener("click", closeModal);
  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });
  document.addEventListener("keydown", handleEscape);
}
